/**
 * Created by zad on 17/12/29.
 */
// 允许的高亮语言
export default [
  'bash',
  'cpp',
  'java',
  'javascript',
  'json',
  'objectivec',
  'php',
  'python',
  'ruby',
  'xml',
  'css',
];



// WEBPACK FOOTER //
// ./src/constants/languages.js